import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/router';
import type React from 'react';
import type { JSX } from 'react';
import GenericTenantSwitcher from '@/components/tenant-switcher';
type TenantSwitcherProps = {
  children: React.ReactNode;
  entityId: string;
  Loading: () => JSX.Element;
};

/**
 * Entity-flavored {@link GenericTenantSwitcher}: after assuming the entity's tenant, rewrite the
 * URL to the correct section (users vs businesses) and canonical fp_id.
 */
const TenantSwitcher = t0 => {
  const $ = _c(10);
  const {
    children,
    entityId,
    Loading
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== entityId || $[1] !== router) {
    t1 = data => {
      if (data.context.object !== "scoped_vault") {
        return;
      }
      const {
        kind,
        fpId
      } = data.context;
      const isEntityPage = /\/(users|businesses)\//.test(router.asPath);
      if (!isEntityPage) {
        return;
      }
      const expectedSection = kind === "business" ? "businesses" : "users";
      const isWrongSection = !router.asPath.includes(`/${expectedSection}/`);
      const isDifferentFpId = fpId !== entityId;
      if (isWrongSection || isDifferentFpId) {
        const newPath = router.asPath.replace(/\/(users|businesses)\//, `/${expectedSection}/`).replace(entityId, fpId);
        router.replace(newPath);
      }
    };
    $[0] = entityId;
    $[1] = router;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== children) {
    t2 = <div>{children}</div>;
    $[3] = children;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== Loading || $[6] !== entityId || $[7] !== t1 || $[8] !== t2) {
    t3 = <GenericTenantSwitcher id={entityId} Loading={Loading} onSwitched={t1}>{t2}</GenericTenantSwitcher>;
    $[5] = Loading;
    $[6] = entityId;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export default TenantSwitcher;